import { render, staticRenderFns } from "./BorderVariants.vue?vue&type=template&id=5460b1f3"
import script from "./BorderVariants.vue?vue&type=script&lang=js"
export * from "./BorderVariants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports